import { createAPI } from '@/request.js'

// 代理列表
export const list = data => createAPI('/api/partner/query.mt', 'post', data)

// 钱包
export const wallet = data => createAPI('/api/partner/wallet/get.mt', 'post', data)
// 商家周收益
export const week = data => createAPI('/api/partner/week/profit.mt', 'post', data)
// 收益明细
export const statement = data => createAPI('/api/partner/statement/query.mt', 'post', data)
// 明细导出
export const excel = data => createAPI('/download/partner/statement/excel', 'get', data)
// 解除认证
export const cancelCredit = data => createAPI('/api/partner/credit/cancel.mt', 'post', data)
// 确认认证
export const confirmCredit = data => createAPI('/api/partner/credit/confirm.mt', 'post', data)
// 认证记录
export const creditList = data => createAPI('/api/partner/credit/modify/log.mt', 'post', data)
// 调整提现规则
export const withdraw = data => createAPI('/api/partner/withdraw/modify.mt', 'post', data)
